import script from "./SkewedTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedTabs.vue?vue&type=script&setup=true&lang=js"

import "./SkewedTabs.vue?vue&type=style&index=0&id=1b6cc43a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6cc43a"]])

export default __exports__